import APIConfiguration from '@savgroup-front-common/configuration/api';
import { SUPPORTED_METHODS } from '@savgroup-front-common/constants/shared/supportedMethods';
import { prepareResponseFailure } from '@savgroup-front-common/core/helpers';
import { apiCall } from '@savgroup-front-common/core/services';
import {
  BaseBackResponse,
  UserPreferences,
} from '@savgroup-front-common/types';

const ENDPOINT = `${APIConfiguration.authorization}users/me/preferences`;

export const setUserPreferenceCommand = async ({
  preferences,
}: {
  preferences: UserPreferences;
}): Promise<BaseBackResponse> => {
  try {
    const response = await apiCall<BaseBackResponse>(ENDPOINT, {
      method: SUPPORTED_METHODS.POST,
      json: { preferences },
    });

    return response;
  } catch (error) {
    return prepareResponseFailure(error);
  }
};
